import React from "react";
import { cn } from "../lib/utils";
import { Skeleton } from "./ui/skeleton";

export const EmptyState = ({ icon: Icon, title, description, action, className, testId = "empty-state" }) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-card px-6 py-12 text-center",
      className
    )}
    data-testid={testId}
  >
    {Icon ? (
      <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-full bg-secondary text-muted-foreground">
        <Icon className="h-5 w-5" />
      </span>
    ) : null}
    <p className="text-sm font-semibold">{title}</p>
    {description ? (
      <p className="mt-1.5 max-w-sm text-xs leading-relaxed text-muted-foreground">{description}</p>
    ) : null}
    {action ? <div className="mt-5">{action}</div> : null}
  </div>
);

export const TableSkeleton = ({ rows = 6, cols = 4 }) => (
  <div className="overflow-hidden rounded-xl border border-border" data-testid="page-loading-skeleton">
    <div className="surface-2 flex gap-4 border-b border-border px-3 py-2.5">
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className="h-3 flex-1" />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex gap-4 border-b border-border px-3 py-3 last:border-0">
        {Array.from({ length: cols }).map((_, c) => (
          <Skeleton key={c} className="h-3.5 flex-1" />
        ))}
      </div>
    ))}
  </div>
);
